module.exports = __webpack_public_path__ + "img/meeting1.32115cf5.jpeg";